import React from "react"
import { Link,graphql } from "gatsby"

import Layout from "../../components/layout"
import HeaderLarge from "../../components/headerLarge"
import SEO from "../../components/seo"
import GuideStarComponent from "../../components/guideStarComponent2020"
import InsurerListPerCategory from "../../components/insurerListPerCategory"

export const query = graphql`
{            
  site {
    siteMetadata {
      title,
      year
    }
  },
  allFritidsbatforsikring2020Csv(sort: {fields: Defaqto_Stjerne, order: DESC}) {
    edges {
      node{
        Provider
        Product
        Defaqto_Stjerne
      }
    }
  }
  allProviders2020: allFritidsbatforsikring2020Csv(sort:{fields: Provider, order: ASC}){
    edges{
      node{
        Provider
      }
    }
  }
}
`

const IndexPage = ({data}) => (
  <Layout>
    <SEO title={`De beste båtforsikringene i ${data.site.siteMetadata.year} | Komplett oversikt`}
         description={"Best i test båtforsikring. Oversikt over alle tilbydere av båtforsikringer med vurderinger av de beste forsikringene til båt i det norske markedet - forsikringene med best vilkår og som gir de beste dekningene."}
         schema={`
              {
              "@context": "https://schema.org",
              "@type": "BreadcrumbList",
              "itemListElement": [{
                "@type": "ListItem",
                "position": 1,
                "name": "Bestforsikring.no",
                "item": "https://bestforsikring.no"
              },{
                "@type": "ListItem",
                "position": 2,
                "name": "Båtforsikring",
                "item": "https://bestforsikring.no/bat"
              }]
            }
         `}
    />
    <HeaderLarge
      siteSection={"bat"}
      Year={"2021"}
      Entity={"båt"}
      Launched={false}
      siteHeading={<>De BESTE <span style={{fontSize:"86%"}}>båtforsikringene</span></>}
      siteDescription={<><span>Vi rangerer de beste båtforsikringene i Norge basert på fakta om </span><u>kvalitet på vilkårene</u><span> - ikke subjektive meninger.</span></>}/>

    <section id="section-content" className="content page-33 moto-section" data-widget="section" data-container="section">

      <div className="moto-widget moto-widget-row row-fixed moto-bg-color5_5 moto-spacing-top-large moto-spacing-right-auto moto-spacing-bottom-large moto-spacing-left-auto" data-grid-type="sm" data-widget="row" data-spacing="lala" style={{}} data-bg-position="left top" data-draggable-disabled>
        <div className="container-fluid">
          <div className="row" data-container="container">
            <div className="moto-widget moto-widget-row__column moto-cell col-sm-12 moto-spacing-top-auto moto-spacing-right-auto moto-spacing-bottom-auto moto-spacing-left-auto" style={{}} data-widget="row.column" data-container="container" data-spacing="aaaa" data-bg-position="left top">
              <div className="moto-widget moto-widget-text moto-preset-default moto-spacing-top-auto moto-spacing-right-auto moto-spacing-bottom-medium moto-spacing-left-auto" data-widget="text" data-preset="default" data-spacing="aama" data-visible-on="mobile-v" data-animation data-draggable-disabled>
                <div className="moto-widget-text-content moto-widget-text-editable">
                  <h1 className="moto-text_system_12" style={{textAlign: 'center'}}>Ønsker du å sammenligne forsikring til lengre båtturer eller til enklere fritidsformål?</h1>
                  <p className="moto-text_system_7" style={{textAlign: 'center'}}><br /></p>
                  <p className="moto-text_system_7" style={{textAlign: 'center'}}>Trykk på en av knappene under for å komme til de respektive oversiktene</p>
                  <p className="moto-text_system_7" style={{textAlign: 'center'}}><br /></p>


                  <p className="moto-text_system_7" style={{textAlign: 'center'}}><br /></p>

                  <div data-widget-id="wid__button__5c9764a4e3084" className="moto-widget moto-widget-button moto-preset-4 moto-align-center moto-spacing-top-auto moto-spacing-right-auto moto-spacing-bottom-auto moto-spacing-left-auto  " data-widget="button">
                    <Link style={{marginLeft:20, marginRight:20, marginTop:20}} to="/bat/turbat" data-action="page" className="moto-widget-button-link moto-size-medium moto-link"><span className="fa moto-widget-theme-icon" /> <span className="moto-widget-button-label">Turbåt</span></Link>

                    <Link style={{marginLeft:20, marginRight:20, marginTop:20}} to="/bat/fritidsbat" data-action="page" className="moto-widget-button-link moto-size-medium moto-link"><span className="fa moto-widget-theme-icon" /> <span className="moto-widget-button-label">Fritidsbåt</span></Link>
                  </div>

                  <p className="moto-text_system_7" style={{textAlign: 'center'}}><br /></p>


                  {/*<p className="moto-text_system_8" style={{textAlign: 'center'}}>
                    Følgende forsikringer er de aller beste båtforsikringene som tilbys i det norske markedet nå - det vil si alle forsikringer som har oppnådd 5 Defaqto Stjerner:
                  </p>

                  <p className="moto-text_system_7" style={{textAlign: 'center'}}><br /></p>

                  <div className={"container-fluid"}>
                    <div className={"row"} data-container={"container"}>
                      {data.allReiseforsikring2020Csv.edges.map(({node: forsikring}) => (
                        <>
                          {
                            forsikring.Defaqto_Stjerne.toString() === "5" &&
                            <GuideStarComponent key={forsikring.Provider+forsikring.Product+forsikring.Defaqto_Stjerne} Section={"bat"} Provider={forsikring.Provider} Stars={forsikring.Defaqto_Stjerne} Product={forsikring.Product} Year={"2020"}/>
                          }
                        </>
                      ))}
                    </div>
                  </div>

                  <p className="moto-text_system_7" style={{textAlign: 'center'}}><br /></p>

                  <div data-widget-id="wid__button__5c9764a4e3084" className="moto-widget moto-widget-button moto-preset-4 moto-align-center moto-spacing-top-auto moto-spacing-right-auto moto-spacing-bottom-auto moto-spacing-left-auto  " data-widget="button">
                    <a style={{marginLeft:20, marginRight:20, marginTop:20}} href="/bat/2020/sammenlign" data-action="page" className="moto-widget-button-link moto-size-medium moto-link"><span className="fa moto-widget-theme-icon" /> <span className="moto-widget-button-label">Vis hele listen</span></a>
                    <a style={{marginLeft:20, marginRight:20, marginTop:20}} href="/bat/2020/guide" data-action="page" className="moto-widget-button-link moto-size-medium moto-link"><span className="fa moto-widget-theme-icon" /> <span className="moto-widget-button-label">Les guiden vår</span></a>
                  </div>

                  <p className="moto-text_system_7" style={{textAlign: 'center'}}><br /></p>

                  <p className="moto-text_normal" style={{textAlign: 'center'}}>
                    Lurer du på hvor mange Defaqto stjerner som er godt nok for ditt forsikringsbehov? Ta en titt på <Link to={"/bat/2020/guide"}>forsikringsguiden vår til båt</Link>.
                  </p>
                  */}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="moto-widget moto-widget-row row-fixed moto-spacing-top-large moto-spacing-right-auto moto-spacing-bottom-large moto-spacing-left-auto" data-widget="row" data-spacing="lala" style={{}} data-bg-position="left top" data-draggable-disabled><div className="container-fluid"><div className="row" data-container="container"><div className="moto-cell col-sm-12 moto-widget moto-widget-row__column" data-container="container" data-widget="row.column" style={{}} data-bg-position="left top"><div className="moto-widget moto-widget-text moto-preset-default moto-spacing-top-auto moto-spacing-right-auto moto-spacing-bottom-auto moto-spacing-left-auto" data-widget="text" data-preset="default" data-spacing="aaaa" data-animation data-draggable-disabled data-visible-on="mobile-v">
        <div className="moto-widget-text-content moto-widget-text-editable"><h2 style={{textAlign: 'center'}} className="moto-text_system_5">Vi har vurdert båtforsikringer fra følgende selskaper:</h2></div>
      </div><div className="moto-widget moto-widget-row moto-spacing-top-small moto-spacing-right-auto moto-spacing-bottom-auto moto-spacing-left-auto" data-grid-type="sm" data-widget="row" data-spacing="saaa" style={{}} data-bg-position="left top">
        <div className="container-fluid">
          <div className="row" data-container="container">
            <div className="moto-widget moto-widget-row__column moto-cell col-sm-12 moto-spacing-top-auto moto-spacing-right-auto moto-spacing-bottom-auto moto-spacing-left-auto" style={{}} data-widget="row.column" data-container="container" data-spacing="aaaa" data-bg-position="left top">
            </div>
          </div>
        </div>
      </div><div className="moto-widget moto-widget-row moto-spacing-top-auto moto-spacing-right-auto moto-spacing-bottom-auto moto-spacing-left-auto" data-grid-type="sm" data-widget="row" data-spacing="aaaa" style={{}} data-bg-position="left top" data-draggable-disabled>
        <div className="container-fluid">
          <div className="row" data-container="container">
            <div className="moto-widget moto-widget-row__column moto-cell col-sm-6 moto-spacing-top-auto moto-spacing-right-auto moto-spacing-bottom-auto moto-spacing-left-auto" style={{}} data-widget="row.column" data-container="container" data-spacing="aaaa" data-bg-position="left top">
              <div className="moto-widget moto-widget-text moto-preset-default moto-spacing-top-auto moto-spacing-right-auto moto-spacing-bottom-auto moto-spacing-left-auto" data-widget="text" data-preset="default" data-spacing="aaaa" data-visible-on="mobile-v" data-animation>
                <div className="moto-widget-text-content moto-widget-text-editable"><p className="moto-text_normal companyStrong">Vi har som mål å dekke alle selskapene som tilbyr forsikringsprodukter for båtforsikring i Norge.</p></div>
              </div></div><div className="moto-widget moto-widget-row__column moto-cell col-sm-6 moto-spacing-top-auto moto-spacing-right-auto moto-spacing-bottom-auto moto-spacing-left-auto" style={{}} data-widget="row.column" data-container="container" data-spacing="aaaa" data-bg-position="left top">
            <div className="moto-widget moto-widget-text moto-preset-default moto-spacing-top-auto moto-spacing-right-auto moto-spacing-bottom-auto moto-spacing-left-auto" data-widget="text" data-preset="default" data-spacing="aaaa" data-visible-on="mobile-v" data-animation data-draggable-disabled>
              <div className="moto-widget-text-content moto-widget-text-editable">
                <p className="moto-text_normal">
                  {<InsurerListPerCategory objList={data.allProviders2020}/>}
                </p>

              </div>
            </div></div>
          </div>
        </div>
      </div></div></div></div></div>
    </section>
  </Layout>
)

export default IndexPage

function slugifier(input) {

  let slugString = input;

  return slugString
  //.toLowerCase()
    .replace(/æ/g,'ae')
    .replace(/ø/g,'o')
    .replace(/å/g,'aa')
    .replace(/&/g,'og')
    .replace(/[^a-zA-Z0-9\/]+/g, '-')
    .replace(/\/-/g,'/')
    .slice(0, 96)                                             // Setting max length to 96
    .replace(/-$/g,'')
}